/**
 * Shared Pay Type Colors and Configuration
 * Use these constants throughout the app for consistency
 */

// Pay type colors - consistent across all charts
export const PAY_TYPE_COLORS = {
  overtime: '#2E5C8A',      // Brand Blue
  double_time: '#FF8C42',   // Brand Orange
  shift2: '#4CAF93',        // Brand Green/Teal
  shift3: '#1e3a5f',        // Brand Navy
  holiday: '#9B59B6',       // Royal Purple — Holiday
  pto: '#95a5a6'            // Slate Gray — PTO
};

// Fallback palette for any unknown pay types (cycled deterministically).
const DYNAMIC_PALETTE = [
  '#2E5C8A', '#FF8C42', '#4CAF93', '#1e3a5f',
  '#9B59B6', '#E74C3C', '#F1C40F', '#16A085',
  '#34495E', '#D35400', '#27AE60', '#8E44AD'
];

// Stable color resolver — same pay type always gets the same color.
const _payTypeColorCache = {};
export const getPayTypeColor = (payType) => {
  if (!payType) return DYNAMIC_PALETTE[0];
  const key = String(payType).toLowerCase();
  // Brand-locked mappings first
  if (key === 'overtime') return PAY_TYPE_COLORS.overtime;
  if (key === 'double time' || key === 'double_time') return PAY_TYPE_COLORS.double_time;
  if (key === 'shift2') return PAY_TYPE_COLORS.shift2;
  if (key === 'shift3') return PAY_TYPE_COLORS.shift3;
  if (key === 'holiday') return PAY_TYPE_COLORS.holiday;
  if (key === 'pto') return PAY_TYPE_COLORS.pto;
  // Deterministic fallback based on hashed key
  if (_payTypeColorCache[key]) return _payTypeColorCache[key];
  let hash = 0;
  for (let i = 0; i < key.length; i++) hash = (hash * 31 + key.charCodeAt(i)) >>> 0;
  const color = DYNAMIC_PALETTE[hash % DYNAMIC_PALETTE.length];
  _payTypeColorCache[key] = color;
  return color;
};

// Pay type display names with multipliers (multipliers loaded from API)
export const PAY_TYPE_LABELS = {
  overtime: 'Overtime',
  double_time: 'Double Time',
  shift2: 'SHIFT2',
  shift3: 'SHIFT3'
};

// Default multipliers (will be overridden by API values)
export const DEFAULT_MULTIPLIERS = {
  'Overtime': 1.5,
  'Double Time': 2.0,
  'SHIFT2': 1.1,
  'SHIFT3': 1.15
};

// Get display label with multiplier
export const getPayTypeLabel = (payType, multipliers = DEFAULT_MULTIPLIERS) => {
  const mult = multipliers[payType] || DEFAULT_MULTIPLIERS[payType] || 1.0;
  return `${payType} (${mult}x)`;
};

// Chart color array for consistent ordering
export const CHART_COLORS = [
  PAY_TYPE_COLORS.overtime,
  PAY_TYPE_COLORS.shift2,
  PAY_TYPE_COLORS.double_time,
  PAY_TYPE_COLORS.shift3
];

export default PAY_TYPE_COLORS;
